import { MARQUEE } from "../../data/site";

export default function Marquee() {
    const row = (ariaHidden) => (
        <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
            {MARQUEE.map((word) => (
                <span key={word} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-serif text-lg italic text-amber-200/60 sm:text-xl">
                        {word}
                    </span>
                    <span className="text-amber-500/60">✶</span>
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="marquee"
            className="relative overflow-hidden border-y border-amber-500/15 bg-[#1F1510] py-5"
        >
            <div className="marquee-track">
                {row(false)}
                {row(true)}
            </div>
        </div>
    );
}
